import { Component, Host, Prop, h, Event, EventEmitter } from '@stencil/core';
import plusIconSVG from './assets/plus-icon.svg';
import checkmarkSVG from './assets/checkmark.svg';

@Component({
    tag: 'plus-wall',
    styleUrl: 'plus-wall.css',
    shadow: true,
})
export class PlusWall {

    // Event names for external reference
    static readonly REGISTER_EVENT = 'plusWallRegisterClick';
    static readonly LOGIN_EVENT = 'plusWallLoginClick';

    @Prop() loginLink: string;
    @Prop() isLoggedIn: boolean;

    /**
    * Event emitted when register button is selected.
    */
    @Event({ eventName: 'plusWallRegisterClick' }) registerEvent: EventEmitter<void>;

    /**
    * Event emitted when login is selected.
    */
    @Event({ eventName: 'plusWallLoginClick' }) loginEvent: EventEmitter<void>;

    /**
     * Handles register button click and emits a `registerEvent` event.
     */
    private handleRegisterClick(): void {
        this.registerEvent.emit()
    }

    /**
     * Handles login button click and emits a `loginEvent` event.
     */
    private handleLoginClick(): void {
        this.loginEvent.emit()
    }

    render() {
        return (
            <Host>
                <div class="plus-wall-container">
                    <div class="wall-icon">
                        <img src={plusIconSVG} alt='plus'></img>
                    </div>
                    <div class="content">
                        <div class="info">
                            <p class="subtitle">Gewisse Artikel benötigen extra Aufwand</p>
                            <p class="title">Unterstütze unabhängigen Qualitätsjournalismus</p>
                        </div>

                        <slot></slot>

                        <div class="plus-box" >
                            <div class="benefits">
                                <div class="benefit"><img src={checkmarkSVG}></img>Unbegrenzter Zugriff auf PLUS+ Inhalte</div>
                                <div class="benefit"><img src={checkmarkSVG}></img>Keine Werbebanner und kein Werbetracking</div>
                                <div class="benefit"><img src={checkmarkSVG}></img>Geräteübergreifend (Web & App)</div>
                                <div class="benefit"><img src={checkmarkSVG}></img>Exklusive Artikel und Analysen</div>
                            </div>
                            <div class={`plus-actions ${this.isLoggedIn ? ' align-center' : ''}`}>
                                <button class={`join-plus ${this.isLoggedIn ? ' full-width' : ''}`} onClick={() => this.handleRegisterClick()} aria-label={'Jetzt PLUS+ Mitglied werden'}
                                    title={'Jetzt PLUS+ Mitglied werden'}>
                                    Jetzt PLUS+ Mitglied werden
                                </button>
                                {
                                    !this.isLoggedIn && <div class="login-plus">Bereits Plus+ Mitglied? <a href={this.loginLink} onClick={() => this.handleLoginClick()} title="anmelden">Anmelden</a></div>
                                }

                            </div>
                        </div>
                    </div>
                </div>
            </Host>
        );
    }
}
